import Link from 'next/link';
import { useState } from 'react'
import moment from 'moment';
import ImageWithFallback from '@/Component/Common/ImageWithFallback';
import PrimaryButton from '@/Component/Common/Forms/PrimaryButton';
import { formatNumberWithCommas } from '@/Utils/Other/FormatNumberWithCommas';
import { BrandPayment } from '@/Utils/APIRequest/Endpoints';
import usePost from '@/Utils/Hooks/usePost';
import { CustomToast } from '@/Utils/CustomToast';
import { LoaderSVG } from '@/Component/Common/SVGs/CommonSVG';

const PaymentCampaignInfluencer = (props) => {
    const { data, userDetails, index, setModal, translations, refetch, setOpenSideModal, fullData } = props;
    const [hoveredIndex, setHoveredIndex] = useState(null);

    // API Payment post
    const { isPending, mutate } = usePost(BrandPayment, null, async (response) => {
        if (response.status == 200 || response.status == 201) {
            CustomToast("success", translations?.paymentSuccessful)
            refetch();
        }
    }, null)

    const handleButtonClick = (data) => {
        if (data?.payment_mode == 'offline') {
            const obj: any = {
                "card_id": 'NO_CARD',
                "payment_id": data?.id
            }
            mutate(obj)
            return;
        }
        setModal({ id: data?.id });
    }

    return (
        <div className="grid grid-cols-12 gap-4 py-6 border-b border-lightGray last:border-0">
            <div className='flex flex-col gap-y-6 md:col-span-6 col-span-12'>
                <div className='flex items-center gap-2.5'>
                    <div className='min-w-12 w-12 h-12 rounded-full overflow-hidden bg-gray flex items-center justify-center'>
                        <ImageWithFallback src={data?.influencer?.image} alt={data?.influencer?.display_name} width={48} height={48} />
                    </div>
                    <div className='flex flex-col'>
                        <h5 className='font-semibold text-base leading-6' >{data?.influencer?.display_name}</h5>
                        <div className='flex items-center gap-2'>
                            <span className='text-xs leading-6'>{data?.influencer?.country}</span>
                            <div className='w-1 h-1 bg-gray rounded-full'></div>

                            {data?.influencer?.influencerCategories?.length > 0 ?
                                <>
                                    <span className='line-clamp-1 text-xs'>{data?.influencer?.influencerCategories?.slice(0, 1).map((category) => category?.category?.translations?.[0]?.title)}</span>
                                    {data?.influencer?.influencerCategories?.length > 1 && (
                                        <span
                                            className='relative text-primary underline cursor-pointer whitespace-nowrap text-xs'
                                            onMouseEnter={() => setHoveredIndex(index)}
                                            onMouseLeave={() => setHoveredIndex(null)}
                                        >
                                            {` +${data?.influencer?.influencerCategories?.length - 1} more`}
                                            {hoveredIndex === index && (
                                                <div className="absolute top-full right-0 bg-white text-black p-2 rounded shadow-lg w-max z-10">
                                                    {data?.influencer?.influencerCategories?.slice(1).map((category, idx) => (
                                                        category?.category !== null &&
                                                        <div key={idx} className="text-xs">{category?.category?.translations?.[0]?.title}</div>
                                                    ))}
                                                </div>
                                            )}
                                        </span>
                                    )}
                                </> : null
                            }

                        </div>
                    </div>
                </div>
                <span className='text-sm'>{moment(data?.createdAt).format('DD MMM YYYY')} - {moment(data?.updatedAt).format('DD MMM YYYY')}</span>
            </div>
            <div className='flex flex-col md:gap-y-3 items-start md:col-span-3 sm:col-span-6 col-span-12'>
                {data?.campaignPayment?.payment_mode == 'offline' ? <span className={`rounded-md px-2.5 text-white font-medium text-xs capitalize py-0.5 max-md:mb-1 bg-gray`}>
                    {translations?.offline} {translations?.payment}
                </span> :
                    data?.campaignPayment?.payment_mode == 'force_offline' ?
                        <span className={`rounded-md px-2.5 text-white font-medium text-xs capitalize py-0.5 max-md:mb-1 bg-gray`}>
                            {translations?.byConnectorClub}
                        </span>
                        :

                        <span className={`rounded-md px-2.5 text-white font-medium text-xs capitalize py-0.5 max-md:mb-1 ${data?.campaignPayment?.payment_status == 'completed' ? 'bg-green-500' : 'bg-red-500'}`}>
                            {translations?.payment} {data?.campaignPayment?.payment_status == 'completed' ? translations?.completed : translations?.pending}
                        </span>
                }
                <span className='font-semibold text-sm'>${formatNumberWithCommas(data?.campaignPayment?.amount)} {data?.campaignPayment?.currency}</span>

                {data?.campaignPayment?.payment_mode == 'offline' ?
                    <></> :
                    data?.campaignPayment?.payment_mode == 'online' ?
                        <span className='text-sm'>{translations?.paymentReleasedOn} {moment(data?.campaignPayment?.created_at).format('DD MMM')}</span>
                        : data?.campaignPayment?.payment_mode == 'force_offline' && data?.campaignPayment?.is_admin_paid ?
                            <span className='text-sm'>{translations?.paymentReleasedOn} {moment(data?.campaignPayment?.updated_at).format('DD MMM')}</span>
                            :
                            <></>
                }
            </div>
            <div className='md:col-span-3 sm:col-span-6 col-span-12 sm:self-center sm:text-end sm:justify-end'>
                {data?.campaignPayment?.payment_status == 'completed' ?
                    <>
                        {(data?.campaignPayment?.payment_mode == 'offline') &&
                            // <span className='font-medium min-w-40 inline-block text-center max-sm:w-full'></span>
                            <div className='flex items-end gap-2.5 flex-col'>
                                <span className='font-medium min-w-40 inline-block text-center max-sm:w-full text-sm' dangerouslySetInnerHTML={{ __html: translations?.payCreatorSeparately }}></span>
                                <PrimaryButton customClass="min-w-40 max-sm:w-full" onClick={() => {
                                    setOpenSideModal({ campaignDetailId: fullData?.id, slug: fullData?.slug, status: 'closed', influencerData: { influencer: data?.influencer } });
                                }}>{translations?.contactNow}</PrimaryButton>
                            </div>
                        }
                        {(data?.campaignPayment?.payment_mode == 'online' && data?.campaignPayment?.invoice_url) &&
                            <Link href={userDetails?.campaign_receipt_path + data?.campaignPayment?.invoice_url} className='bg-lightGray rounded-md px-3 py-2 font-medium text-sm min-w-40 inline-block text-center hover:shadow-[0_0_0_3px_rgba(185,218,255,1)] transition-shadow max-sm:w-full' target="_blank" download={true}>{translations?.downloadInvoice}</Link>
                        }
                    </>
                    : data?.campaignPayment?.payment_mode == 'force_offline' ?
                        <></>
                        : <PrimaryButton buttonType="button" customClass="!py-2 min-w-40 !rounded-md !border-red-500 !bg-red-500 flex items-center justify-center gap-1.5 justify-self-end" onClick={() => handleButtonClick(data?.campaignPayment)} >
                            {translations?.payNow}
                            {isPending && <LoaderSVG />}
                        </PrimaryButton>
                }
            </div>
        </div>
    )
}

export default PaymentCampaignInfluencer
